import {Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField} from '@mui/material';
import React, {Component} from 'react';
import Select from '../../components/Select';

// Tenant account_status dialog — wraps the support /tenants/{id}/status PUT.
// Backend transitions accounts.account_status (BILLING layer); the legacy
// TENANT_STATUS_* enum (which mixed identity + business terms) was retired
// per docs/ADR_TENANT_STATUS_AND_TIER.md. UI sends snake_case
// {account_status: "trial"|"active"|"blocked"|"terminated"} now.
//
// Identity-layer state (zitadel ORGANIZATION_STATE_*) is read-only here —
// support flips per-user IAM state from the customer detail Users tab, not
// at the tenant level.

// 'Trial' is intentionally NOT an option: trial is an ENTRY state, created once
// via the "Start Trial (Run Lifecycle Setup)" action when no account exists. The
// backend state machine has no transition whose TARGET is trial — this dialog
// only transitions an existing account to active/blocked/terminated/testing.
//
// 'Testing' pins the tenant's SMS routes to the test SMPP operator (the
// status-transition handler rewrites tenant_smsc_route). Reachable from
// trial/active only — the backend rejects blocked/terminated → testing.
const ACCOUNT_STATUS_OPTIONS = [
  {value: 'ACCOUNT_STATUS_ACTIVE',     name: 'Active'},
  {value: 'ACCOUNT_STATUS_BLOCKED',    name: 'Blocked'},
  {value: 'ACCOUNT_STATUS_TERMINATED', name: 'Terminated'},
  {value: 'ACCOUNT_STATUS_TESTING',    name: 'Testing'},
];

// Translate the lowercase DB form (live in OrganizationV2.account_status) into
// the enum for the Select. Anything we don't recognize falls through to ACTIVE
// to give the operator a sensible default to edit.
function toEnum(rawStatus) {
  if (!rawStatus) return 'ACCOUNT_STATUS_ACTIVE';
  if (rawStatus.startsWith('ACCOUNT_STATUS_')) return rawStatus;
  switch (rawStatus.toLowerCase()) {
    // A trial account can only transition OUT (active/blocked/terminated), so
    // default the picker to Active — the natural "activate" action.
    case 'trial':       return 'ACCOUNT_STATUS_ACTIVE';
    case 'active':      return 'ACCOUNT_STATUS_ACTIVE';
    case 'blocked':     return 'ACCOUNT_STATUS_BLOCKED';
    case 'terminated':  return 'ACCOUNT_STATUS_TERMINATED';
    case 'testing':     return 'ACCOUNT_STATUS_TESTING';
    default:            return 'ACCOUNT_STATUS_ACTIVE';
  }
}

export default class ChangeStatus extends Component {
  constructor(props){
    super(props);
    this.state = {
      val: toEnum(props.status),
      reason: ''
    }
  }
  handleChange = (e) => this.setState({val: e.target.value});
  handleReasonChange = (e) => this.setState({reason: e.target.value});
  render(){
    const {val, reason} = this.state;
    // Require a reason when blocking or terminating — both are
    // non-trivial actions the audit log should record context for.
    const reasonRequired = val === 'ACCOUNT_STATUS_BLOCKED' || val === 'ACCOUNT_STATUS_TERMINATED';
    return(
      <Dialog open={true} onClose={this.props.closeChangeStatus}>
        <DialogTitle>Change Account Status</DialogTitle>
        <DialogContent style={{paddingTop: 16}}>
          <Select
            label="Account Status"
            value={val}
            fullWidth
            required
            onChange={this.handleChange}
            options={ACCOUNT_STATUS_OPTIONS}
            sx={{minWidth: 220}}
          />
          {reasonRequired && (
            <TextField
              label={val === 'ACCOUNT_STATUS_TERMINATED' ? 'Termination Reason' : 'Block Reason'}
              value={reason}
              onChange={this.handleReasonChange}
              fullWidth
              required
              multiline
              rows={2}
              sx={{marginTop: 2}}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.closeChangeStatus}>Cancel</Button>
          <Button
            variant='contained'
            onClick={() => this.props.changeStatus({
              account_status: val,
              ...(reasonRequired && reason ? {reason} : {})
            })}
            disabled={reasonRequired && !reason}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}
